<template>
    <van-popup v-model:show="show" position="bottom" :overlay-style="{ overflow: 'hidden' }" :style="{
        minWidth: '100%',
        minHeight: '100%',
        color: '#fff',
        zIndex: '1998'

    }">
        <div class="popupContainer">
            <CustomHeader :text="$t('misteryBox.supriseRewards')" :isPopupCloseBackIcon="true" @close-popup="close" />
            <div class="container">
                <van-row class="topCard">
                    <van-col span="12" class="columnContainer">
                        <div><van-icon name="point-gift" size="20px" color="#fff" /></div>
                        <div class="prizeText">{{ $t('misteryBox.totalPrize') }}</div>
                        <div class="prizeAmount" style="color: rgb(248, 189, 28);">{{ 'R$ ' +
                            formatCurrency(totalPrizeAmount) }}</div>
                    </van-col>
                    <van-col span="12" class="columnContainer">
                        <div><van-icon name="balance-list" size="20px" color="#fff" /></div>
                        <div class="prizeText">{{ $t('misteryBox.alreadyClaimed') }}</div>
                        <div class="prizeAmount">{{ 'R$ ' + formatCurrency(totalClaimedAmount) }}</div>
                    </van-col>
                </van-row>
                <GiftCard @update-info="updateInfoData"
                    v-if="nonDepositButtonConfig && (nonDepositButtonConfig?.available || nonDepositButtonConfig?.alreadyClaimed)"
                    :rewardType="1" :already-claimed="nonDepositButtonConfig?.alreadyClaimed"
                    :title="$t('misteryBox.nonrechargeUsers')"
                    :bottom-text="$t('misteryBox.dailyPrize') + getFirstAndLastAmount(nonDepositButtonConfig?.mysteryBoxLevel?.config)" />
                <GiftCard @update-info="updateInfoData"
                    v-if="depositButtonConfig && (depositButtonConfig?.available || depositButtonConfig?.alreadyClaimed)"
                    :rewardType="2" :already-claimed="depositButtonConfig?.alreadyClaimed"
                    :title="$t('misteryBox.rechargeUsers')"
                    :bottom-text="$t('misteryBox.dailyPrize') + getFirstAndLastAmount(depositButtonConfig?.mysteryBoxLevel?.config)" />
                <GiftCard @update-info="updateInfoData"
                    v-if="todayDepositButtonConfig && (todayDepositButtonConfig?.available || todayDepositButtonConfig?.alreadyClaimed)"
                    :rewardType="3" :already-claimed="todayDepositButtonConfig?.alreadyClaimed"
                    :title="$t('misteryBox.rechargeUsersToday')"
                    :bottom-text="$t('misteryBox.limitedPeopleText', { value: getPeoplePerDay(todayDepositButtonConfig) })" />
                <GiftCard @update-info="updateInfoData"
                    v-if="mysteryRewardButtonConfig && (mysteryRewardButtonConfig?.available || mysteryRewardButtonConfig?.alreadyClaimed)"
                    :rewardType="4" :already-claimed="mysteryRewardButtonConfig?.alreadyClaimed"
                    :title="$t('misteryBox.randomLuckyPrize')"
                    :bottom-text="$t('misteryBox.prize') + getFirstAndLastAmount(mysteryRewardButtonConfig?.mysteryBoxLevel?.config)" />
                <NoData v-if="isEmptyList" />
            </div>

        </div>
    </van-popup>
</template>


<script setup lang="ts">
import CustomHeader from '../components/common/customHeader.vue';
import { computed, PropType, ref } from 'vue';
import GiftCard from './components/giftCard.vue';
import { getFirstAndLastAmount, getPeoplePerDay, MisteryBoxConfigData } from '@/view/misteryBox/supportScript';
import { formatCurrency } from '@/utils/commonFunction';
import NoData from '../components/common/noData.vue';

const emits = defineEmits(['open', 'close', 'updateInfo', 'update:show'])
const props = defineProps({
    dataSet: {
        type: Object as PropType<MisteryBoxConfigData>,
        required: true
    }
})
const depositButtonConfig = computed<any>(() => props.dataSet.depositButtonConfig)
const mysteryRewardButtonConfig = computed<any>(() => props.dataSet.mysteryRewardButtonConfig)
const nonDepositButtonConfig = computed<any>(() => props.dataSet.nonDepositButtonConfig)
const todayDepositButtonConfig = computed<any>(() => props.dataSet.todayDepositButtonConfig)
const totalClaimedAmount = computed<number>(() => props.dataSet.totalClaimedAmount)
const totalPrizeAmount = computed<number | string>(() => props.dataSet.totalPrizeAmount)
const isEmptyList = computed<boolean>(() => props.dataSet.isEmptyList)
const updateInfoData = () => {
    emits('updateInfo')
}
const show = computed({
    get: () => props.dataSet.show,
    set: (val) => emits('update:show', val)
})

const open = () => {
    emits('open')
}
const close = () => {
    emits('close')
}

</script>
<style scoped>
.van-popup {
    background-color: rgb(0, 45, 45);
    width: 100%;
    min-height: 90vh;
    padding-bottom: 100px;
    -ms-overflow-style: none;
    scrollbar-width: none;
    overflow-y: auto;
    z-index: 1998;
}

.van-popup::-webkit-scrollbar {
    display: none;
}
.van-overlay {
    z-index: 1997 !important;
}
.container {
    padding: 70px 15px;

}

.topCard {
    border-radius: 5px;
    background-color: #024A49;
    color: #fff;
    padding: 15px;
}

.columnContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.prizeText {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.721);
    padding: 5px 0;
}

.prizeAmount {
    font-size: 20px;
    font-weight: 500;
}
</style>